/**
 * Extended Warranty add-on — app-agnostic, added WITH the product (never alone).
 *
 * This store's Add-to-Cart is owned by external cart apps (SlideCart HQ / AMP / GoKwik) that add the
 * product via XHR and bypass the theme's ProductForm + `variant:add` event. We must not re-fire the
 * ATC button (that loops). So:
 *   - Ticking the checkbox does NOT touch the cart (avoids the "warranty alone in cart" problem).
 *   - On Add-to-Cart / Buy Now click (passive — no preventDefault, no re-fire), we wait for the
 *     device line to land in the cart, then add the warranty line alongside it and nudge the drawer.
 *
 * Gated by snippets/warranty-addon.liquid — absent markup ⇒ every handler short-circuits.
 */
(function () {
  if (window.__warrantyAddonInit) return;
  window.__warrantyAddonInit = true;

  var TRIGGER_SELECTOR = 'buy-buttons button[type="submit"], form[is="product-form"] button[type="submit"], button[name="add"], [data-add-to-cart], #gokwik-buy-now, .gokwik-checkout button';

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function fd(u) { return u + (u.indexOf('?') < 0 ? '?' : '&') + '_fd=0'; }
  function getBox() { return document.querySelector('.warranty-addon__checkbox'); }
  function isChecked() { var b = getBox(); return !!(b && b.checked); }
  function warrantyId() { var b = getBox(); return b ? String(b.getAttribute('data-warranty-variant-id')) : null; }

  // --- Per-variant warranty swap -------------------------------------------------
  // The buy-box combo picker swaps the product variant, and the warranty that should
  // attach varies by variant (e.g. the AFO + Cold Press Juicer combo -> ₹1,999 instead
  // of the ₹1,199 single-appliance cover). warranty-addon.liquid emits a map
  // (variant id -> { id, label, covers, sub }) on .warranty-addon[data-warranty-map].
  // We keep the checkbox's data-warranty-variant-id (read at ATC time by addWarranty)
  // and the visible price/sub in sync as the variant changes.
  function getMap() {
    var el = document.querySelector('.warranty-addon[data-warranty-map]');
    if (!el) return null;
    try { return JSON.parse(el.getAttribute('data-warranty-map')); } catch (e) { return null; }
  }
  function currentVariantId() {
    var input = document.querySelector('form[id*="product-form"] input[name="id"]')
             || document.querySelector('input[name="id"]');
    return input ? String(input.value) : null;
  }
  function syncWarranty() {
    var map = getMap();
    if (!map) return;                       // product has no per-variant map — nothing to swap
    var vid = currentVariantId();
    if (!vid) return;
    var entry = map[vid];
    if (!entry) {
      // No warranty for this variant — hide the add-on and clear any tick.
      document.querySelectorAll('.warranty-addon').forEach(function (c) { c.style.display = 'none'; });
      document.querySelectorAll('.warranty-addon__checkbox').forEach(function (b) { b.checked = false; });
      return;
    }
    document.querySelectorAll('.warranty-addon').forEach(function (c) { c.style.display = ''; });
    document.querySelectorAll('.warranty-addon__checkbox').forEach(function (b) {
      b.setAttribute('data-warranty-variant-id', entry.id);   // checked state is preserved on purpose
      b.setAttribute('data-warranty-covers', entry.covers || '');
    });
    document.querySelectorAll('.warranty-addon__price').forEach(function (p) { p.textContent = '+' + entry.label; });
    document.querySelectorAll('.warranty-addon__sub').forEach(function (s) { if (entry.sub) s.textContent = entry.sub; });
  }

  function getCart() {
    return fetch(fd(root() + 'cart.js'), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  function addWarranty() {
    var b = getBox();
    if (!b) return Promise.resolve();
    var id = b.getAttribute('data-warranty-variant-id');
    var covers = b.getAttribute('data-warranty-covers') || '';
    if (!id) return Promise.resolve();
    return getCart().then(function (cart) {
      var has = cart && (cart.items || []).some(function (i) { return String(i.variant_id) === String(id); });
      if (has) return; // never double-add
      return fetch(fd(root() + 'cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: covers ? { Covers: covers } : {} }] })
      }).catch(function () {});
    });
  }

  // nudge whichever cart app is active to re-read /cart.js
  function refreshCart() {
    ['cart:refresh', 'cart:change', 'cart:updated'].forEach(function (ev) {
      try {
        document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
      } catch (e) {}
    });
  }

  // Keep multiple warranty checkboxes (main + sticky) in sync. NO cart mutation on toggle.
  document.addEventListener('change', function (event) {
    var box = event.target.closest && event.target.closest('.warranty-addon__checkbox');
    if (!box) return;
    document.querySelectorAll('.warranty-addon__checkbox').forEach(function (other) {
      if (other !== box) other.checked = box.checked;
    });
  });

  // On Add-to-Cart / Buy Now: wait for the device to land, then add the warranty alongside it.
  // Passive (no preventDefault / no re-fire) so it can never block the buy flow or loop.
  document.addEventListener('click', function (event) {
    if (!isChecked()) return;
    if (!(event.target.closest && event.target.closest(TRIGGER_SELECTOR))) return;
    var id = warrantyId();
    var tries = 0;
    (function waitForDevice() {
      tries++;
      getCart().then(function (cart) {
        var items = cart ? (cart.items || []) : [];
        var hasWarranty = items.some(function (i) { return String(i.variant_id) === String(id); });
        if (hasWarranty) { refreshCart(); return; }
        var deviceLanded = items.some(function (i) { return String(i.variant_id) !== String(id); });
        if (deviceLanded) {                 // device is in the cart — add the warranty alongside it
          addWarranty().then(refreshCart);
          return;
        }
        if (tries < 15) setTimeout(waitForDevice, 400);  // wait up to ~6s; if the device never lands, do NOTHING (never warranty-alone)
      });
    })();
  }, true);

  // Re-sync the warranty SKU/price whenever the buy box swaps the product variant.
  // Mirror the triggers sections/main-product-template.liquid uses for its own price
  // update: the theme's variant:change event, the hidden input, and combo-card clicks.
  document.addEventListener('variant:change', function () { setTimeout(syncWarranty, 0); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') setTimeout(syncWarranty, 0);
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.combo__card, .combo__variant_option-values label')) {
      setTimeout(syncWarranty, 120); // let the picker update input[name="id"] first
    }
  }, true);
  function initWarrantySync() {
    var input = document.querySelector('form[id*="product-form"] input[name="id"]')
             || document.querySelector('input[name="id"]');
    if (input && window.MutationObserver) {
      new MutationObserver(function () { syncWarranty(); })
        .observe(input, { attributes: true, attributeFilter: ['value'] });
    }
    syncWarranty(); // initial state — also fixes a deep-link to ?variant=<combo>
  }
  if (document.readyState !== 'loading') initWarrantySync();
  else document.addEventListener('DOMContentLoaded', initWarrantySync);
})();
